module.exports = __webpack_public_path__ + "img/julia.b5f262ca.jpg";